/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../APIClient.jsx";
import {motion} from "motion/react";
import {Subscription} from "../Subscription.js";
import {StatesAPI} from "../APIs/StatesApi.js";
import Strings from "toolbox/strings";

class ElementStatus extends Component {
    constructor() {
        super();
        this.state = {
            currentState: {}
        }

        this.sub = new Subscription()
    }

    async fetchData() {
        let {name, elementId} = this.props
        let tableName = `STATE_${name}`
        let result = await StatesAPI.getStateHistory(name, elementId, 3)
        result = result.sort((a, b) => (b.time - a.time))
        this.setState({currentState: result?.[0]})

        this.sub.add(() => Database.table(tableName, "app").onChange((change) => {
            this.setState({currentState: change.data})
        }, [{
            column: "elementId",
            value: elementId
        }]), "liveData")

    }

    componentDidMount() {
        this.fetchData()

    }

    componentWillUnmount() {
        this.sub.unmount()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.name !== this.props.name || prevProps.elementId !== this.props.elementId) {
            this.fetchData()
        }
    }


    render() {
        let {currentState} = this.state

        let state = currentState?.state ?? ""

        let className = "bg-yellow-50 text-yellow-800  ring-yellow-600/20"

        if (Strings.isEmpty(state)) {
            return <div></div>
        }
        if (state === "ok") {
            className = ""
            return (
                <div className={"flex items-center justify-center"}>
                    <motion.span
                        layout
                        className={`inline-flex items-center w-2 h-2 rounded-full bg-green-300 ${className}`}></motion.span>

                </div>
            );
        } else if (state.startsWith("inSetup")) {
            className = "bg-blue-50 text-blue-700 ring-blue-600/20"
        } else if (state === "waiting") {
            className = "bg-sky-50 text-sky-700 ring-sky-600/20"
        } else {
            className = "bg-red-50 text-red-700 ring-red-600/20"
        }


        return (<>
                <motion.span
                    layout
                    className={`inline-flex items-center rounded-md  px-2 py-1 text-xs font-medium  ring-1 ring-inset ${className}`}>{currentState?.state}</motion.span>

            </>
        );
    }
}

ElementStatus.propTypes = {};

ElementStatus.defaultProps = {};


export default ElementStatus;